import classNames from 'classnames';
import * as dateFnsCompat from 'utils/date-fns-compat';
import { toSafeExternalUrl } from '../../../../utils';

import he from 'he';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { FiCopy } from 'react-icons/fi';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { branch, compose, renderComponent } from 'recompose';
import { bindActionCreators } from 'redux';
import { dateFormats, routes } from '../../../../constants';
import { PublishedEventTypes } from '../../../../constants/publishedEvent';
import { findCpdCategory, getIndustryLabelForCpdCategoryNoParenthesis } from '../../../../services';
import { cpdCategorysActions } from '../../../../state/modules/areas-of-advice';
import { ConfirmationModal, Icon } from '../../../components';
import Loading from '../../loading';

const EventTableFields = (eventType) => ({
  title: {
    title: 'Title',
    field: 'title'
  },
  days: {
    title: 'Days',
    field: 'durationDay'
  },
  minutes: {
    title: 'Minutes',
    field: 'durationMinute'
  },
  dateTimeOfEvent: {
    title: `${eventType} Date`,
    field: `dateTimeOfEvent`
  },
  price: {
    title: 'Price (Fr. $)',
    field: 'price'
  },
  cpdCategory: {
    title: 'CPD Category',
    field: 'cpdCategory'
  },
  cpdPoints: {
    title: 'CPD Hours',
    field: 'cpdPoints'
  },
  status: {
    title: 'Status',
    field: 'status'
  }
});

class EventTable extends Component {

  constructor() {
    super();

    this.state = {
      sorting: {},
      events: []
    };
  }

  componentDidMount() {
    if (this.props.cpdCategorys.length === 0 && !this.props.isFetchingCpdCategorys) {
      this.props.getCpdCategorys();
    }

    // Always try to get all Events to prevent data lose caused by refresh.
    this.props.getEvents(0, { eventType: this.props.eventType });
  }

  componentWillReceiveProps(nextProps) {
    const { eventsPerPage, eventsResult } = nextProps;
    const events = eventsPerPage ?
      fp.take(eventsPerPage)(eventsResult.events) :
      eventsResult.events;

    this.setState({
      events: events
    });
  }

  renderSortingArrow(field) {
    if (this.state.sorting[field] === 'asc') {
      return <Icon icon='arrow-up-medium' />;
    }
    else if (this.state.sorting[field] === 'desc') {
      return <Icon icon='arrow-down-medium' />;
    }
    else {
      return <span><Icon icon='arrow-down-medium' /><Icon icon='arrow-up-medium' /></span>
    }
  }

  renderTableHeadings() {
    return fp.map((heading) =>
      <td key={heading.field} className={heading.field}>
        {this.props.updateBySorting ?
          <Button onClick={() => this.sortBy(heading.field, this.state.sorting[heading.field])} className='heading-btn' bsStyle='plain'>
            {heading.title} &nbsp;
            {
              this.renderSortingArrow(heading.field)
            }
          </Button> :
          <span>{heading.title}</span>
        }
      </td>)(EventTableFields(this.props.eventType));
  }

  sortBy(field, sortOrder) {
    let nextSortOrder = null;
    if (!sortOrder) {
      nextSortOrder = 'asc';
    }

    if (sortOrder === 'asc') {
      nextSortOrder = 'desc';
    }

    if (sortOrder === 'desc') {
      nextSortOrder = undefined;
    }

    // This will remove all other fields' sorting.
    this.setState({
      sorting: { [field]: nextSortOrder }
    });

    this.props.updateBySorting(field, nextSortOrder);
  }

  confirmDelete(event) {
    const nextRoute = this.props.eventType === PublishedEventTypes.Event ? routes.publisherPortal.publishedEvents : routes.publisherPortal.courses
    this.props.deleteEvent(event.id, this.props.currentEventQuery, nextRoute);
    this.closeDeleteModal();
  }

  closeDeleteModal() {
    const updatedEvent = fp.map((a) => Object.assign({}, a, { showDeleteModal: false }))(this.state.events);
    this.setState({
      events: updatedEvent
    });
  }

  deleteEvent(event) {
    const updatedEvent = fp.map((a) => Object.assign({}, a, { showDeleteModal: event.id === a.id }))(this.state.events);
    this.setState({
      events: updatedEvent
    });
  }

  render() {
    const { className, eventEditRoute, eventType, industriesWithCpdCategorys } = this.props;

    return (
      <table className={classNames('table--events', className)}>
        <thead>
          <tr>
            {
              this.renderTableHeadings()
            }
            <td aria-label='actions'>&nbsp;</td>
          </tr>
        </thead>
        <tbody>
          {
            this.state.events.length > 0 ?
              fp.flow(
                fp.map((event) => ({
                  ...event,
                  cpdCategory: event.cpdCategorys.length > 1 ? 'Multiple' : findCpdCategory(event.cpdCategorys[0].cpdCategoryId)(this.props.cpdCategorys).name,
                  cpdPoints: fp.flow(
                    fp.map(
                      (aoaCpdPoint) => ({
                        ...aoaCpdPoint,
                        industry: getIndustryLabelForCpdCategoryNoParenthesis(aoaCpdPoint.cpdCategoryId, industriesWithCpdCategorys)
                      })
                    ),
                    fp.groupBy('industry'),
                    fp.toPairs,
                    fp.map(
                      ([industry, cpdPoints]) => <div key={industry}>{industry.split(' ').map(fp.first).join('')} {fp.sumBy(({ cpdPoints }) => cpdPoints)(cpdPoints)}</div>
                    )
                  )(event.cpdCategorys)
                })),
                fp.map((event) =>
                  <tr key={event.id}>
                    <td className='title'>
                      {
                        event.link ?
                          <Link to={toSafeExternalUrl(he.decode(event.link)) || '#'} target='_blank'>{he.decode(event.title)}</Link> :
                          event.title
                      }
                    </td>
                    <td className='days'>{event.durationDay}</td>
                    <td className='minutes'>{event.durationMinute}</td>
                    <td className='event-date'>{event.dateTimeOfEvent ? dateFnsCompat.format(dateFnsCompat.parse(event.dateTimeOfEvent), dateFormats.ShortDate) : 'Not Set'}</td>
                    <td className='event-price'>{event.price}</td>
                    <td className='event-aoa'>{event.cpdCategory}</td>
                    <td className='cpd-points'>{event.cpdPoints}</td>
                    <td className='status'>{event.status}</td>
                    <td className='edit-row'>
                      <LinkContainer to={{ pathname: `${eventEditRoute(event.id)}` }}>
                        <Button bsStyle='plain'><Icon icon='edit-medium' /> Edit</Button>
                      </LinkContainer>
                      <LinkContainer to={{ pathname: `${routes.publisherPortal.publishedEventDuplicate(event.id)}` }}>
                        <Button bsStyle='plain'><FiCopy /> Duplicate</Button>
                      </LinkContainer>
                      {
                        this.props.allowDelete ?
                          [
                            <ConfirmationModal
                              key={`delete-${event.id}`}
                              show={event.showDeleteModal}
                              actions={[{
                                onConfirmAction: () => this.confirmDelete(event),
                                actionLabel: 'Delete'
                              }]}
                              cancel={() => this.closeDeleteModal()}
                              message={
                                <span>
                                  You are about to delete <b>{event.title}</b>.
                                  &nbsp;
                                  Any CPD earned by users for this {fp.toLower(eventType)} will also be deleted.
                                </span>
                              }
                              headingText={<span>Delete {eventType}</span>}
                            />,
                            <Button key={`edit-${event.id}`} bsStyle='plain' className='warning' onClick={() => this.deleteEvent(event)}><Icon icon='delete-medium' /> Delete</Button>
                          ] : null
                      }
                    </td>
                  </tr>
                )
              )(this.state.events) :
              this.props.isFetching ?
                null :
                <tr>
                  <td colSpan={7}>
                    No events found, click ADD EVENT to add events.
                  </td>
                </tr>
          }
          {
            this.props.isFetching ?
              <tr>
                <td colSpan={7}>
                  <Loading />
                </td>
              </tr> :
              null
          }
        </tbody>
      </table>
    );
  }
}

const mapStateToProps = (state) => ({
  cpdCategorys: state.cpdCategorys.cpdCategorys,
  isFetchingCpdCategorys: state.cpdCategorys.isFetching,
  industriesWithCpdCategorys: state.industry.industriesWithCpdCategorys
});

const mapDispatchToProps = (dispatch) => ({
  getCpdCategorys: bindActionCreators(cpdCategorysActions.cpdCategorys.get, dispatch),
});

EventTable.propTypes = {
  currentEventQuery: PropTypes.object,
  eventsPerPage: PropTypes.number,
  updateBySorting: PropTypes.func,
  allowDelete: PropTypes.bool
};

EventTable.defaultProps = {
  allowDelete: false
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ isFetchingCpdCategorys }) => isFetchingCpdCategorys,
    renderComponent(Loading)
  )
)(EventTable);



// WEBPACK FOOTER //
// ./src/containers/pages/shared/publish-event/event-table.js